import axios from 'axios';
import config from '../config/api';

const API_URL = config.endpoints.especialidades;

export const getEspecialidadesMedico = (page = 1, pageSize = 10) => {
	// If page is provided, request paginated endpoint
	const params = `?page=${page}&pageSize=${pageSize}`;
	return axios.get(API_URL + '/' + params);
};
export const createEspecialidadMedico = (data) => axios.post(API_URL + '/crear', data);
export const updateEspecialidadMedico = (id, data) => axios.put(`${API_URL}/actualizar/${id}`, data);
export const deleteEspecialidadMedico = (id) => axios.delete(`${API_URL}/eliminar/${id}`);
export const getEspecialidadMedicoById = (id) => axios.get(`${API_URL}/id/${id}`);
export const getEspecialidadMedicoByNombre = (nombre) => axios.get(`${API_URL}/nombre/${nombre}`);

// Export agrupado (por si algún import esperaba default u objeto)
export default {
	getEspecialidadesMedico,
	createEspecialidadMedico,
	updateEspecialidadMedico,
	deleteEspecialidadMedico,
	getEspecialidadMedicoById,
	getEspecialidadMedicoByNombre
};
